import GPDto from "../Geschaeftspartner/GPDto";
import KontingentperiodeDto from "../Dashboard/KontingentperiodeDto";

export default class KontingentDto {

  constructor(json) {
    if (json) {
      this.json = json

      this.id = json.id
      this.geschaeftspartner = new GPDto(json.geschaeftspartner)
      this.periode = new KontingentperiodeDto(json.periode)
      this.berechneterWert = json.berechneterWert
      this.angepassterWert = json.angepassterWert
      this.angepasstKommentar = json.angepasstKommentar
      this.versendetElektronischOn = json.versendetElektronischOn
      this.versendetPostalischOn = json.versendetPostalischOn
      this.gpDownloadOn = json.gpDownloadOn
      this.gpDownloadBy = json.gpDownloadBy
      this.status = json.status
      this.elektronischerVersand = !!json.elektronischerVersand
    } else {
      this.json = {}
      this.geschaeftspartner = new GPDto()
      this.periode = new KontingentperiodeDto()
    }
  }

  get gp() {
    return this.geschaeftspartner.name
  }

  get versandart() {
    return this.geschaeftspartner.elektronischeVerfuegung ? 'verfuegung.versandart.elektronisch' : 'verfuegung.versandart.brief'
  }

  get versandadresse() {
    return this.elektronischerVersand ? this.geschaeftspartner.email : this.geschaeftspartner.adresse
  }

  get versanddatum() {
      return this.versendetElektronischOn
  }
}
